


import { useState, useEffect } from 'react';
import { Mail, Lock, Eye, EyeOff, MessageSquare, ArrowRight, } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import A1 from '../Images/elo.png';

import ReCAPTCHA from 'react-google-recaptcha';

export default function LoginScreen({ onLogin, onSwitchToSignup, onWhatsAppLogin, onForgotPassword, }) {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // Track window width for responsive inline adjustments
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 600;
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://cloudapi.emedhatechnologies.com/auth/api/user/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          password,
        }),
      });

      const data = await response.json();

      console.log('LOGIN:', data);

      if (!response.ok) {
        alert(data.error || 'Login failed');
        return;
      }

      if (data.type === 'company') {
        const userData = {
          type: 'company',
          id: data.user.id,
          email: data.user.email,
          company_name: data.user.company_name,
          company_logo: data.user.company_logo,
          type_seperate: data.user.type_seperate,
        };
        sessionStorage.setItem('userData', JSON.stringify(userData));
        if (data.user.company_logo) {
          sessionStorage.setItem('company_logo', data.user.company_logo);
        }

        alert('Company login successful');
        navigate('/dashboard/home');
        return;
      }
      if (data.type === 'employee') {
        sessionStorage.setItem(
          'userData',
          JSON.stringify({
            type: 'employee',
            id: data.user.id,
            parent_company_id: data.user.parent_company_id,
            email: data.user.email,
            name: data.user.name,
            user_type: data.user.user_type,
            permissions: data.user.permissions,
            company_name: data.user.company_name,
            company_logo: data.user.company_logo,
          })
        );

        if (data.user.company_logo) {
          sessionStorage.setItem('companyLogo', data.user.company_logo);
        }
        alert('User login successful');
        navigate('/dashboard/home');
        return;
      }
      alert('Invalid user type');
    } catch (error) {
      console.error('Login error:', error);
      alert('Something went wrong');
    }
  };

  return (
    <div style={{ minHeight: '100vh', width: '100%', backgroundColor: '#f8fafc', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: isMobile ? '16px' : '24px', fontFamily: 'monospace', color: '#0f172a', overflowY: 'auto', boxSizing: 'border-box', }}>
      <header style={{ width: '100%', maxWidth: '1280px', margin: '0 auto', display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: isMobile ? 'center' : 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '24px', gap: '16px', }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', }}>
          <div style={{ height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
            <img src={A1} alt="Logo" style={{ maxHeight: '100%', width: 'auto', display: 'block' }} />
          </div>
        </div>

        <div style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px', textAlign: isMobile ? 'center' : 'right', }}>
          <span style={{ color: '#94a3b8' }}>New here? </span>
          <button onClick={() => navigate('/signup')} style={{ border: 'none', background: 'none', cursor: 'pointer', fontWeight: '700', color: '#000', padding: '4px', }}>Create Account</button>
        </div>
      </header>

      {/* Main Container */}
      <main style={{ width: '100%', maxWidth: '400px', margin: isMobile ? '24px auto' : '40px auto', boxSizing: 'border-box', }}>
        <div style={{ marginBottom: '30px', textAlign: isMobile ? 'center' : 'left', }}>
          <h1 style={{ fontSize: isMobile ? '20px' : '22px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '8px', }}>Welcome Back</h1>
          <p style={{ color: '#94a3b8', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px', }}>SaaS Authentication Portal</p>
        </div>

        {/* WhatsApp Button */}
        <button type="button" onClick={() => navigate('/whatsapplogin')} style={{ width: '100%', height: '44px', border: '1px solid #e2e8f0', backgroundColor: '#fff', borderRadius: '8px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '12px', textTransform: 'uppercase', boxSizing: 'border-box', }}>
          <MessageSquare size={16} color="#25D366" />
          Login via WhatsApp
        </button>

        {/* Divider */}
        <div style={{ display: 'flex', alignItems: 'center', margin: '24px 0', }}>
          <div style={{ flex: 1, height: '1px', backgroundColor: '#e2e8f0' }} />
          <span style={{ margin: '0 12px', fontSize: '10px', color: '#94a3b8', fontWeight: '700', textTransform: 'uppercase', }}>OR</span>
          <div style={{ flex: 1, height: '1px', backgroundColor: '#e2e8f0' }} />
        </div>

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          {/* Email */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '700', color: '#64748b', textTransform: 'uppercase', }}>Email Address</label>

            <div style={{ position: 'relative' }}>
              <Mail size={16} color="#94a3b8" style={{ position: 'absolute', left: '12px', top: '14px', }} />
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@company.com" required style={{ width: '100%', height: '44px', paddingLeft: '40px', paddingRight: '15px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '12px', boxSizing: 'border-box', }} />
            </div>
          </div>

          {/* Password */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', }}>
              <label style={{ fontSize: '12px', fontWeight: '700', color: '#64748b', textTransform: 'uppercase', }}>Password</label>
            </div>

            <div style={{ position: 'relative' }}>
              <Lock size={16} color="#94a3b8" style={{ position: 'absolute', left: '12px', top: '14px', }} />
              <input type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" style={{ width: '100%', height: '44px', paddingLeft: '40px', paddingRight: '40px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '12px', boxSizing: 'border-box', }} />
              <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: '12px', top: '13px', border: 'none', background: 'none', cursor: 'pointer', }}>
                {showPassword ? (
                  <EyeOff size={18} color="#64748b" />
                ) : (
                  <Eye size={18} color="#64748b" />
                )}
              </button>
            </div>
          </div>

          {/* Remember Me */}
          <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px', }}>
            <input type="checkbox" id="rememberMe" />
            <label htmlFor="rememberMe" style={{ fontSize: '11px', color: '#64748b', textTransform: 'uppercase', cursor: 'pointer', }}>Keep me logged in</label>
          </div>

          <div style={{ marginBottom: '20px', width: '100%', display: 'flex', justifyContent: 'center', overflowX: 'auto', }}>
            <ReCAPTCHA sitekey="6LfB4CIqAAAAABTTABOif9nMWUiFuMfIp31_UU5I" />
          </div>

          <button type="submit" style={{ width: '100%', height: '44px', border: 'none', borderRadius: '8px', backgroundColor: '#000', color: '#fff', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', boxSizing: 'border-box', }}>
            Execute Sign In
            <ArrowRight size={16} />
          </button>
        </form>
      </main>

      {/* Footer */}
      <footer style={{ width: '100%', maxWidth: '1280px', margin: '0 auto', borderTop: '1px solid #e2e8f0', paddingTop: '24px', display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: isMobile ? 'center' : 'space-between', alignItems: 'center', gap: '16px', fontSize: '10px', color: '#94a3b8', textTransform: 'uppercase', textAlign: 'center', }}>
        <p>© {new Date().getFullYear()} Cloud Connect Inc.</p>
        <div style={{ display: 'flex', gap: '20px' }}>
          <a href="#" style={{ color: '#94a3b8', textDecoration: 'none' }}>Privacy</a>
          <a href="#" style={{ color: '#94a3b8', textDecoration: 'none' }}>Terms</a>
        </div>
      </footer>
    </div>
  );
}